export default __webpack_public_path__ + "static/card-ramengo-869fed930d9e59ca1be8fc8d82f2b951.png";